import { useTranslation } from 'react-i18next';

import { ConsignmentNumberFilter } from '@/features/dashboard-filters';
import { DateRangePicker, type DateRangeValue } from '@/shared/ui/date-range-picker';

import type { ReceiveHistoryUrlState } from '../model/types';

interface ReceiveHistoryFiltersProps {
  filters: ReceiveHistoryUrlState;
  onFilterChange: (key: keyof ReceiveHistoryUrlState, value: string) => void;
  onDateRangeChange: (dateFrom: string, dateTo: string) => void;
}

/**
 * Receive History filter popover content: consignment number (LIKE) +
 * received-date range, per the API contract. Reuses the shared field
 * components used by the consignments filter bar.
 */
export function ReceiveHistoryFilters({ filters, onFilterChange, onDateRangeChange }: ReceiveHistoryFiltersProps) {
  const { t } = useTranslation();

  const handleDateRangeChange = (value: DateRangeValue) => {
    onDateRangeChange(value.fromDate || '', value.toDate || '');
  };

  return (
    <div className="flex flex-wrap items-start gap-4">
      <ConsignmentNumberFilter
        value={filters.consignmentNumber}
        onChange={(value) => onFilterChange('consignmentNumber', value)}
      />

      <DateRangePicker
        key={`${filters.dateFrom}|${filters.dateTo}`}
        label={t('receive.receivedate.label', 'Actual Date of Receipt')}
        defaultPreset="CR"
        defaultFromDate={filters.dateFrom || undefined}
        defaultToDate={filters.dateTo || undefined}
        onChange={handleDateRangeChange}
      />
    </div>
  );
}
